import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getHeadersFormUrlEncoded } from '@sbt-suite/components';
import * as JsEncryptModule from 'jsencrypt';
import { Observable, lastValueFrom } from 'rxjs';
import { buildUrl } from 'src/app/shared/functions';
import { environment } from 'src/environments/environment';
import { IChavePublica, ICredenciaisUsuario, IRsa } from '../../models';

@Injectable({
    providedIn: 'root'
})
export class RsaService {
    URL_BASE = environment.URL_BASE + environment.PATH;
    PORT_CORE = environment.PORT_CORE;

    private _nonceToken!: string;
    private _senhaEncriptada!: string;

    constructor(private http: HttpClient) {}

    async gerarNonceTokenESenha(dados: ICredenciaisUsuario): Promise<IChavePublica> {
        const { email, senha } = dados;
        const response = await lastValueFrom(this._buscarChavePrivada(email));
        const { nonceToken, key } = response;
        this._nonceToken = nonceToken;
        this._gerarChaveRSA(senha, key);
        return this.getDadosEncriptados();
    }

    getDadosEncriptados(): IChavePublica {
        return { nonceToken: this._nonceToken, senhaEncriptada: this._senhaEncriptada };
    }

    private _buscarChavePrivada(email: string): Observable<IRsa> {
        const params = new HttpParams().set('email', email);
        return this.http.post<IRsa>(
            buildUrl(this.URL_BASE, '/api/v1/login/step', this.PORT_CORE),
            params.toString(),
            {
                headers: getHeadersFormUrlEncoded()
            }
        );
    }

    private _gerarChaveRSA(senha: string, chavePrivada: string) {
        const refChave = '-----BEGIN PUBLIC KEY-----' + chavePrivada + '-----END PUBLIC KEY-----';
        const encrypt = new JsEncryptModule.JSEncrypt();
        encrypt.setPublicKey(refChave);
        const encripted = encrypt.encrypt(senha) as string;
        this._senhaEncriptada = encripted;
    }
}
